import pageKey from 'ui/constants/pageKey';
const eventClickCategoryNews = (param, type) => {
  if (typeof window !== 'undefined' && param) {
    (window as any)?.dataLayer?.push({
      event: `generalEvent`,
      eventName: `${
        type === pageKey.servicePackage
          ? 'paket_servis'
          : type === pageKey.serviceCoupon
            ? 'kupon_servis'
            : type === pageKey.newCarPurchase
              ? 'new_car'
              : type === pageKey.productKnowledge
                ? 'review'
                : 'article'
      }_category_button`,
      eventCategory: `${
        type === pageKey.servicePackage
          ? 'paket servis page'
          : type === pageKey.serviceCoupon
            ? 'kupon servis page'
            : type === pageKey.newCarPurchase
              ? 'new car page'
              : type === pageKey.productKnowledge
                ? 'review produk page'
                : 'article page events'
      }`,
      eventAction: `click on ${param?.toLowerCase()}`,
    });
  }
};
export default eventClickCategoryNews;
